const elems = document.querySelectorAll('div.yt-embed')

if (elems.length > 0) {
	let tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";

	let firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

window.onYouTubeIframeAPIReady = () => {
	elems.forEach((elem) => {
		if (elem.getAttribute('data-yt-autoplay') === 'true' || document.documentElement.clientWidth <= 768) {
			elem.addEventListener('click', initYouTubeEmbed(elem))
		} else {
			initYouTubeEmbed(elem)
		}
	})
}

function initYouTubeEmbed (elem) {
	const autoplay = elem.getAttribute('data-yt-autoplay') === 'true'
	const playerVars = JSON.parse(elem.getAttribute('data-yt-params'))
	const cover = document.getElementById(`${elem.id}_cover`)
	const player = new YT.Player(elem.id, {
		videoId: elem.getAttribute('data-yt-video'),
		playerVars,
		width: elem.clientWidth,
		height: elem.clientHeight,
		events: {
			'onReady': (event) => {
				if (autoplay) {
					event.target.setVolume(0)
					event.target.playVideo()
				}
				if (cover) {
					cover.removeAttribute('disabled')
					cover.addEventListener('click', () => {
						event.target.setVolume(25)
						event.target.playVideo()
					}, true)
				}
			},
			'onStateChange': (event) => {
				// Video ended
				if (playerVars.loop && event.target.getPlayerState() === 0) {
					event.target.playVideo()
				}

				// Video playing
				if (cover && event.target.getPlayerState() === 1) {
					cover.remove()
				}
			}
		}
	})
}
